import { useQuery } from '@tanstack/react-query';

import type {
  GlobalSettings,
  GlobalSettingsKey,
} from '@sola/schema/dotcom/shared/content/settings.ts';

import { getSettings, getSettingsByKey } from './utils/routes';

/**
 * React Query hook for fetching content settings.
 * @returns The result of the query
 */
export const useContentSettings = () => {
  return useQuery({
    queryKey: ['contentSettings'],
    queryFn: () => {
      return getSettings();
    },
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

/**
 * React Query hook for fetching a single content setting by key.
 * Uses SDG's `/settings/{key}` endpoint so the client only downloads when it needs.
 */
export const useContentSettingsValue = <T extends GlobalSettingsKey>(
  key: T,
) => {
  return useQuery({
    queryKey: ['contentSettings', key],
    queryFn: () => getSettingsByKey<GlobalSettings[T]>(key),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
